/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ThreatsConcentrationByProviderWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("ThreatsConcentrationByProviderWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return ThreatsConcentrationByProviderWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<ThreatsConcentrationByProviderWidgetConfiguration>): ThreatsConcentrationByProviderWidgetConfiguration {
        let obj = Object.assign(new ThreatsConcentrationByProviderWidgetConfiguration(), model);
        ThreatsConcentrationByProviderWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ThreatsConcentrationByProviderWidgetConfiguration>): ThreatsConcentrationByProviderWidgetConfiguration {
        if (!model) return null;
        return ThreatsConcentrationByProviderWidgetConfiguration.newInstance(<ThreatsConcentrationByProviderWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ThreatsConcentrationByProviderWidgetConfiguration) {
        if (!obj) return;

        models.ThreatsConcentrationByProviderWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ThreatsConcentrationByProviderWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ThreatsConcentrationByProviderWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
